import validate from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_ae37c24451277770959eb013c11808d8/node_modules/nuxt/dist/pages/runtime/validate.js";
import login_45redirect_45global from "/home/vsts/work/1/s/middleware/loginRedirect.global.ts";
import manifest_45route_45rule from "/home/vsts/work/1/s/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_ae37c24451277770959eb013c11808d8/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  login_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}